<form [formGroup]="itemForm()">
  <div class="app-tf-head">
    <button
      class="app-tf-status"
      matIconButton
      (click)="formsService.getFormValidationErrors(itemForm())"
    >
      <mat-icon
        [style]="{
          color: formsService.hasFormValidationErrors(itemForm()) ? 'red' : 'gray'
        }"
      >
        error_outline
      </mat-icon
      >
    </button>
  </div>
  <div
    class="app-tf-grid"
    [style]="{
      'background-color': itemForm().controls.visible.value ? '' : 'lightgray'
    }"
  >
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label i18n>Select Type</mat-label>
      <mat-select
        formControlName="type"
        (selectionChange)="changeType($event.value)"
      >
        @if (itemForm().controls.type.value !== null) {
          <mat-select-trigger class="app-type-trigger">
            <mat-icon>{{ inputTypeIcons[itemForm().controls.type.value] }}</mat-icon>
            {{ inputTypes[itemForm().controls.type.value] }}
          </mat-select-trigger>
        }
        @for (type of inputTypes | keyvalue; track type) {
          <mat-option [value]="+type.key" class="app-type-option">
            <mat-icon>{{ inputTypeIcons[+type.key] }}</mat-icon>
            {{ type.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (itemForm().controls.type.value !== null) {
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <input
          matInput
          formControlName="name"
          placeholder="Header"
          i18n-placeholder
        />
      </mat-form-field>
      <mat-checkbox class="app-check-box" formControlName="required" i18n>
        Required
      </mat-checkbox>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label i18n>Column Width</mat-label>
        <input
          matInput
          formControlName="width"
          placeholder="relative width"
          i18n-placeholder
        />
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label i18n>Position</mat-label>
        <input
          type="number"
          matInput
          formControlName="sort"
          placeholder="Position"
          i18n-placeholder
        />
      </mat-form-field>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label i18n>Column key</mat-label>
        <input
          [readonly]="isDeviceTableColumn()"
          matInput
          formControlName="columnKey"
          [style]="{ 'font-style': isDeviceTableColumn() ? 'italic' : '' }"
        />
      </mat-form-field>
      @if ((selectedType === +TableFieldTypeT.DROPDOWN || selectedType ===
        +TableFieldTypeT.RADIO) && !isDeviceTableRequiredColumn()) {
        <div class="option-row app-tf-full">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="option-field">
            <input
              matInput
              placeholder="Option list"
              i18n-placeholder
              #inputTmp
              name="inputTmp"
              (change)="onTextChange($event)"
            />
            <button
              matButton
              matSuffix
              type="button"
              aria-label="Add"
              i18n-aria-label
              (click)="onAddButtonClick(); inputTmp.value = ''"
            >
              <mat-icon class="cust-mat-icon">add</mat-icon>
            </button>
          </mat-form-field>

          @let values = getValues();
          @if (values.length > 0) {
            <button
              mat-icon-button
              type="button"
              aria-label="Edit values"
              i18n-aria-label
              (click)="editValues()"
              class="edit-values-btn"
            >
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>
        <div class="selected-options app-tf-full">
          @for (option of values | slice : 0 : 2; track option; let i = $index) {
            <span class="app-multi-label">
      {{ option.value | slice : 0 : 8 }}{{ option.value.length > 8 ? '...' : '' }}
    </span>
          }

          @if (values.length > 2) {
            <span class="app-multi-label more-badge">
      +{{ values.length - 2 }} <span i18n>more</span>
    </span>
          }
        </div>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label i18n>Select default value</mat-label>
          <mat-select formControlName="defaultValue">
            @for (option of values; track option) {
              <mat-option [value]="option.value">
                {{ option.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (itemForm().controls.columnKey.value === 'productCategoryUuid') {
        @if ((productCategoriesMap$ | async); as categMap) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label i18n>select default category</mat-label>
            <mat-select
              formControlName="defaultValue"
              (selectionChange)="onDefaultProductCategoryChange($event.value)"
            >
              @for (option of categMap | keyvalue; track option) {
                <mat-option [value]="option.key">{{ option.value }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      }
      @if (selectedType !== +TableFieldTypeT.EXPRESSION && selectedType !==
      +TableFieldTypeT.CONDITION && selectedType !== +TableFieldTypeT.DROPDOWN &&
      selectedType !== +TableFieldTypeT.RADIO && !isDeviceTableRequiredColumn()) {
        @if (tableType() !== FormTableT.AGGREGATE) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              formControlName="defaultValue"
              placeholder="defaultValue"
              i18n-placeholder
            />
          </mat-form-field>
        }
        @if (tableType() === FormTableT.AGGREGATE) {
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input
              matInput
              formControlName="defaultValue"
              placeholder="filterValue"
              i18n-placeholder
            />
          </mat-form-field>
        }
      }
      @if (selectedType === +TableFieldTypeT.EXPRESSION) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="app-tf-full">
          <form [formGroup]="expForm">
            <input
              matInput
              placeholder="Expression"
              formControlName="expression"
              i18n-placeholder
              [errorStateMatcher]="expressionErrorMatcher"
              (input)="onExprChange($event)"
            />
          </form>
          @if (expForm.controls.expression.errors?.expressionSyntax; as expressionErrors) {
            <mat-error>
              @for (msg of expressionErrors; track msg) {
                <div>{{ msg }}</div>
              }
            </mat-error>
          } @else if (expressionWarnings(); as exprWarnings) {
            @if (exprWarnings.length > 0) {
              <mat-hint class="app-expr-warning">
                @for (msg of exprWarnings; track msg) {
                  <div>{{ msg }}</div>
                }
              </mat-hint>
            }
          }
        </mat-form-field>
      }
      @if (selectedType === +TableFieldTypeT.CONDITION) {
        <div>
          <button matIconButton (click)="openConditionDialog()">
            <mat-icon>functions</mat-icon>
          </button>
          <p></p>
        </div>
      }
      @if (tableType() === FormTableT.AGGREGATE) {
        <div class="app-tf-full" style="padding-bottom: 10px; padding-top: 5px">
          <mat-checkbox
            class="app-check-box"
            formControlName="aggregate"
            (change)="aggregateSelected(itemForm())"
          >
            @if (itemForm().controls.aggregate.value) {
              <span i18n>Aggregate </span>
            }
            @if (!itemForm().controls.aggregate.value) {
              <span i18n>Dimension</span>
            }
          </mat-checkbox>
          @if (itemForm().controls.aggregate.value) {
            <mat-select
              formControlName="formTableAggregateType"
              (selectionChange)="onAggregateTypeChanged(itemForm(), $event)"
            >
              @for (aggrType of TableAggregateT | keyvalue; track aggrType; let i =
                $index) {
                <mat-option [value]="+aggrType.key">{{ aggrType.value }}</mat-option>
              }
            </mat-select>
          }
        </div>
      }
      <div class="app-tf-full app-tf-actions">
        @if (itemForm().controls.visible.value) {
          <button
            type="button"
            matIconButton
            (click)="changeVisible(itemForm())"
            aria-label="Hide column"
            i18n-aria-label
          >
            <mat-icon>visibility</mat-icon>
          </button>
        } @else {
          <button
            type="button"
            matIconButton
            (click)="changeVisible(itemForm())"
            aria-label="Show column"
            i18n-aria-label
          >
            <mat-icon>visibility_off</mat-icon>
          </button>
        }
        @if (!isDeviceTableColumn()) {
          <button
            type="button"
            matIconButton
            color="warn"
            (click)="delete()"
            aria-label="Delete column"
            i18n-aria-label
          >
            <mat-icon>delete</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</form>
